import HttpRequest from '@/libs/api.axios'
import globConfig from '@/config/config';

const baseUrl = globConfig.apiUrl.dev;
const axios = new HttpRequest(baseUrl);
export default axios


// WEBPACK FOOTER //
// ./src/libs/api.request.js